import { createTheme } from '@mui/material/styles';

export const getAppTheme = (isCorporate = false) => {
  return createTheme({
    palette: {
      mode: 'light',
      primary: {
        main: '#0a0068',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#cc4049',
      },
      text: {
        primary: '#1a202c',
        secondary: '#4a5568',
      },
      background: {
        default: '#ffffff',
        paper: '#ffffff',
      },
    },
    typography: {
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
            fontWeight: 600,
            borderRadius: 8,
          },
          containedPrimary: {
            backgroundColor: '#0a0068',
            color: '#ffffff',
            '&:hover': {
              backgroundColor: '#08004d',
            },
          },
          outlinedPrimary: {
            borderColor: '#0a0068',
            color: '#0a0068',
            '&:hover': {
              borderColor: '#08004d',
              backgroundColor: 'rgba(10, 0, 104, 0.08)'
            },
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            color: '#4a5568',
            '&.Mui-focused': { color: '#0a0068' },
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#E0E0E0',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#9AA6AC',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#0a0068',
            },
          },
        },
      },
    },
  });
};

export default getAppTheme;
